const statusMap = {
  0: { name: '待提交', color: 'blue' },
  1: { name: '待乡镇审核', color: 'orange' },
  2: { name: '乡镇审核退回', color: 'red' },
  3: { name: '待区级审核', color: 'purple' },
  4: { name: '区级审核通过', color: 'green' },
  5: { name: '区级审核退回', color: 'red' }
}

export const statusDict = Object.entries(statusMap).map(
  ([value, { name }]) => ({
    name,
    value
  })
)

// 资源管理页面公共表头配置
export const resourceHeaderConfig = {
  // 搜索表头配置
  header: [
    {
      name: '资源名称',
      type: 'input',
      key: 'name',
      placeholder: '请输入资源名称'
    },
    {
      name: '资源类型',
      type: 'select',
      key: 'resourcesType',
      placeholder: '请选择资源类型',
      dictType: 'housing_resources_type',
      typeData: []
    },
    {
      name: '用地性质',
      type: 'select',
      key: 'landUseNature',
      placeholder: '请选择用地性质',
      dictType: 'housing_land_use_nature',
      typeData: []
    },
    {
      name: '招募类型',
      type: 'select',
      key: 'recruitType',
      placeholder: '请选择招募类型',
      dictType: 'recruitment_type',
      typeData: []
    }
  ],

  // 表格列配置
  columns: [
    {
      dataIndex: 'name',
      title: '资源名称',
      align: 'left',
      width: 300
    },
    {
      dataIndex: 'resourcesTypeLabel',
      title: '资源类型',
      align: 'left',
      width: 120
    },
    {
      dataIndex: 'siteArea',
      title: '占地面积 (m²)',
      align: 'left',
      width: 120
    },
    {
      dataIndex: 'floorArea',
      title: '建筑面积 (m²)',
      align: 'left',
      width: 120
    },
    {
      dataIndex: 'address',
      title: '地理位置',
      align: 'left',
      width: 300
    },
    {
      dataIndex: 'landUseNatureLabel',
      title: '用地性质',
      align: 'left',
      width: 120
    },
    {
      dataIndex: 'createByName',
      title: '上报人',
      align: 'left',
      width: 120
    },
    {
      dataIndex: 'createTime',
      title: '上报时间',
      align: 'left',
      width: 180
    },
    {
      dataIndex: 'sort',
      title: '排序',
      align: 'left',
      width: 120
    },
    {
      dataIndex: 'status',
      title: '审核状态',
      type: 'badge',
      align: 'left',
      width: 120,
      onExport: text => {
        return (statusMap[text] || { name: '未知', color: 'gray' }).name
      },
      render(data) {
        const status = statusMap[data] || { name: '未知', color: 'gray' }
        return {
          showDot: true,
          name: status.name,
          color: status.color
        }
      }
    },
    {
      dataIndex: 'upDown',
      title: '上架状态',
      type: 'badge',
      align: 'left',
      width: 120,
      onExport: records => {
        return ['上架', '下架'][records]
      },
      render(data) {
        return {
          showDot: true,
          name: data == '0' ? '上架' : '下架',
          color: data == '0' ? 'green' : 'red'
        }
      }
    }
  ]
}
